module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/calendar-2bf4861434f21557690847ca2832defd.svg";